// Presentation constants for dilli.wiki. Place/list DATA now comes from the backend API.

export const categories = [
  { id: "og-spots", label: "OG Spots", subtitle: "the institutions. eating here is a rite of passage.", color: "#e07a5f" },
  { id: "chaat-street", label: "Chaat & Street", subtitle: "purani dilli energy. eat standing, no regrets.", color: "#f2a541" },
  { id: "gourmet", label: "Gourmet", subtitle: "for when you want to dress up a little.", color: "#9b5de5" },
  { id: "coffee", label: "Coffee", subtitle: "the third-wave has well and truly arrived.", color: "#8d6e63" },
  { id: "sweet-tooth", label: "Sweet Tooth", subtitle: "dessert is a separate stomach.", color: "#ef476f" },
  { id: "pints", label: "Pints", subtitle: "sundowners, speakeasies and stiff pours.", color: "#118ab2" },
  { id: "date-plans", label: "Date Plans", subtitle: "places that do half the talking for you.", color: "#06d6a0" },
  { id: "things-to-do", label: "Things to Do", subtitle: "beyond eating (but also, eating).", color: "#3d5a80" },
];

export const cityCenter = { lat: 28.6139, lng: 77.219 };
